
import Vue from 'vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'
import ItemCard from '@/components/project/ItemCard.vue'
import PagedResults from '@/service/PagedResults'
import { ContestWinner, SimpleContest } from '@/model/Contest'

export default Vue.extend({
  name: 'UserContests',
  components: {
    ServerPaginationList,
    ItemCard,
  },
  props: {
    userId: {
      type: String,
    },
  },
  mounted() {
    this.fetchWinners()
  },
  computed: {
    winnersGrouped: function (): Record<string, ContestWinner[]> {
      const result = {} as Record<string, ContestWinner[]>
      for (let i = 0; i < this.winners.length; i++) {
        const winner = this.winners[i]
        const contest = winner.contest as SimpleContest
        if (!contest.contestId) {
          continue
        }
        if (!(contest.contestId in result)) {
          result[contest.contestId] = []
        }
        result[contest.contestId].push(winner)
      }

      return result
    },
  },
  data: () => ({
    winners: [] as ContestWinner[],
  }),
  methods: {
    fetchWinners: function () {
      const winnersLoader = new PagedResults<ContestWinner[]>(this.$api)
      winnersLoader
        .all('contests/winners', 30, {
          userId: this.userId
        })
        .then((result) => (this.winners = result))
    },
  },
  watch: {
    userId: function () {
      this.fetchWinners()
    },
  },
})
